import HIGHLIGHT from '@/data/timeline-highlight-map';

/**
 * Method for replacing string to highlighted keyword
 *
 * @param {array} linksProcessed -  [message] array with 1 element message.
 * @param {function} createElement - vue method
 * @returns {array} on highlighted keyword
 */

const highlightStates = ({
    linksProcessed,
    createElement,
}) => linksProcessed.map((particle) => {
    if (typeof particle === 'string' && !!particle) {
        return HIGHLIGHT.reduce((acc, {keyword, type = ''}) => {
            const matchWholeWord = new RegExp(`\\b${keyword}\\b`, 'i');
            if (typeof acc === 'string' && particle.match(matchWholeWord)) {
                const [first, ...rest] = particle.split(matchWholeWord);
                return [
                    first,
                    createElement('span', {class: `highlight highlight-${type}`}, keyword),
                    ...rest,
                ];
            }
            return acc;
        }, particle);
    }
    return particle;
});

export default highlightStates;
